// src/services/UserHomepageSectionsService.js
import API from "../api/apiUser";

/**
 * Service for fetching dynamically-editable homepage sections.
 */
export const UserHomepageSectionsService = {
    getSections: async () => {
        try {
            const response = await API.get("/user/homepage/sections");
            return response.data;
        } catch (error) {
            console.error("Error fetching homepage sections:", error);
            throw error;
        }
    },
};
